import { render, staticRenderFns } from "./joinChannel.vue?vue&type=template&id=564d5866&scoped=true&"
import script from "./joinChannel.vue?vue&type=script&lang=js&"
export * from "./joinChannel.vue?vue&type=script&lang=js&"
import style0 from "./joinChannel.vue?vue&type=style&index=0&id=564d5866&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564d5866",
  null
  
)

export default component.exports